import {pluralize} from 'common/util/string';
import {COUNT_TYPE_OPTIONS, ORDER_OPTIONS} from 'common/report/funnels/models/constants';
import {ConversionWindow, CountType, FunnelOrder} from 'common/report/funnels/models/types';

export function getFunnelOrderSections(funnelOrder: FunnelOrder) {
  return [
    {
      items: ORDER_OPTIONS.map((option) => ({
        ...option,
        isSelected: option.value === funnelOrder,
      })),
    },
  ];
}

export function getFunnelOrderLabel(funnelOrder: FunnelOrder): string {
  const funnelOrderSections = getFunnelOrderSections(funnelOrder);
  const selectedFunnelOrder = funnelOrderSections[0].items.filter((section) => {
    return section.isSelected;
  });
  return selectedFunnelOrder[0].label;
}

export function getCountTypeSections(countType: CountType, showSessions: boolean) {
  const options = COUNT_TYPE_OPTIONS.filter(({value}) => (value === CountType.Session ? showSessions : true));

  return [
    {
      items: options.map((option) => ({
        ...option,
        isSelected: option.value === countType,
      })),
    },
  ];
}

export function getCountTypeLabel(countType: CountType, showSessions: boolean): string {
  const countTypeSections = getCountTypeSections(countType, showSessions);
  const selectedCountType = countTypeSections[0].items.filter((value) => {
    return value.isSelected;
  });
  return selectedCountType[0].label;
}

export function getConversionWindowLabel(conversionWindow: ConversionWindow): string {
  const {value, unit} = conversionWindow;
  return `${value} ${pluralize(unit, value)}`;
}
